module.exports = __webpack_public_path__ + "files/b68543ea0154859fd5ea790ef52b73d6.png";